import { TableColumnId } from "./manage-ceg-table-container.enum";
import { budgetAllocationColumns, newCustomAvailableBudgetManageTableConfiguration } from "../../constants/manage-ceg-page.constants";
import { LocalStorageService } from "@common-lib/services/local-storage.service";

export const MANAGE_PAGE_FIELDS = 'MANAGE_PAGE_FIELDS';

export default class ManageCegTableContainerStore {
  static _managePageFields = undefined;
  static get managePageFields() {
    return ManageCegTableContainerStore._managePageFields;
  }
  static set managePageFields(config) {
    this._managePageFields = config;

    LocalStorageService.addToStorage(MANAGE_PAGE_FIELDS, config);
    Object.keys(this.dbId2TableColumnNameMap).forEach((key, i) => {
      newCustomAvailableBudgetManageTableConfiguration.columns[i].label = config[i].name; // set label from manage page fields for new CAB Config
      budgetAllocationColumns[key].label = (config[i].name).split(' '); // set column name on Manage CEG Table from manage page fields
    });

  }

  static get dbId2TableColumnNameMap() {
    return {
      budget: TableColumnId.Budget,
      forecast: TableColumnId.Forecast,
      actual: TableColumnId.Actual,
      committed: TableColumnId.Committed,
      planned: TableColumnId.Planned,
      available: TableColumnId.Available,
    }
  }
};
